import { observer } from 'mobx-react-lite'
import { EmptyState } from 'shared/ui'
import agentPreviewImg from 'shared/assets/images/agent/agent_preview.png'
import { getCDNAssetURL } from 'shared/lib'
import { ChatbotHelpGuideButton, ChatbotNewButton } from 'pages/chatbot/ui'

export const ChatbotListEmpty = observer(() => {
  return (
    <EmptyState
      variant='preview'
      previewImg={<img alt='Chatbot preview' src={getCDNAssetURL(agentPreviewImg)} />}
      title='Create your first AI Agent'
      subtitle={'Automate replies, qualify leads, and book meetings with your AI agent'}
      actions={
        <>
          <ChatbotNewButton />
          <ChatbotHelpGuideButton />
        </>
      }
    />
  )
})
